var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashBinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25837 2.84584H7.03516C7.15793 2.84584 7.25837 2.7454 7.25837 2.62263V2.84584H15.7405V2.62263C15.7405 2.7454 15.841 2.84584 15.9637 2.84584H15.7405V4.85477H17.7494V2.62263C17.7494 1.6377 16.9487 0.836914 15.9637 0.836914H7.03516C6.05022 0.836914 5.24944 1.6377 5.24944 2.62263V4.85477H7.25837V2.84584ZM21.3209 4.85477H1.67801C1.18415 4.85477 0.785156 5.25377 0.785156 5.74763V6.64049C0.785156 6.76325 0.885603 6.8637 1.00837 6.8637H2.69364L3.38281 21.4563C3.42746 22.4078 4.21429 23.1583 5.16574 23.1583H17.8332C18.7874 23.1583 19.5714 22.4106 19.6161 21.4563L20.3052 6.8637H21.9905C22.1133 6.8637 22.2137 6.76325 22.2137 6.64049V5.74763C22.2137 5.25377 21.8147 4.85477 21.3209 4.85477ZM17.6183 21.1494H5.38058L4.70536 6.8637H18.2935L17.6183 21.1494Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinIcon);
export default __webpack_public_path__ + "static/media/trash-bin-icon.fba7e51893ecb1bcf71c89269ab59ec9.svg";
export { ForwardRef as ReactComponent };